import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { RouteProps } from 'react-router-dom';

import { RouteConfig } from './index';
import { fromLayout, useAppDispatch } from '../store';

const DEFAULT_PAGE_TITLE = 'app.page.title';

type RouteWithPageTitleProps = RouteProps & {
  pageTitle?: RouteConfig['pageTitle'];
  showSidebar?: RouteConfig['showSidebar'];
};

const RouteWithPageTitle = (props: RouteWithPageTitleProps) => {
  const { pageTitle, element, showSidebar } = props;
  const intl = useIntl();
  const dispatch = useAppDispatch();

  useEffect(() => {
    document.title = intl.formatMessage({ id: pageTitle || DEFAULT_PAGE_TITLE });
    dispatch(fromLayout.setShowSideBar(showSidebar ?? true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // set only once
  return <>{element}</>;
};

export default RouteWithPageTitle;
